"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./activity.scss");

var _uuid = _interopRequireDefault(require("uuid"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const colorOptions = [{
  start: 'FC4548',
  end: 'FFB100'
}, {
  start: 'FFB100',
  end: '00D5B6'
}, {
  start: '00D5B6',
  end: '924DFC'
}, {
  start: '924DFC',
  end: 'FC4548'
}, {
  start: 'FFB100',
  end: '924DFC'
}, {
  start: '00D5B6',
  end: 'FC4548'
}];

class ActivityGradientSelector extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      start: null,
      end: null,
      bothSet: false
    };

    this.setGradient = grad => {
      const {
        setGradient
      } = this.props;
      const {
        start,
        end
      } = this.state;

      if (grad.start !== start || grad.end !== end) {
        setGradient(grad.start, grad.end);
        this.setState({
          start: grad.start,
          end: grad.end
        });
      }
    };
  }

  componentDidMount() {
    const {
      gradient
    } = this.props;

    if (gradient) {
      this.setState({
        start: gradient.start,
        end: gradient.end
      });
    }
  }

  render() {
    const {
      disabled
    } = this.props;
    const {
      start,
      end
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "activity-gradient"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "color-panel"
    }, colorOptions.map(grad => {
      return /*#__PURE__*/_react.default.createElement("button", {
        key: (0, _uuid.default)(),
        disabled: disabled,
        style: {
          background: `linear-gradient(#${grad.start}, #${grad.end})`
        },
        className: ['color-option', grad.start === start && grad.end === end ? 'selected' : ''].join(' '),
        onClick: e => {
          e.stopPropagation();
          this.setGradient(grad);
        }
      });
    })));
  }

}

var _default = ActivityGradientSelector;
exports.default = _default;